import * as React from 'react';
interface IFrameOverlayProps {
    visibility: boolean;
}
const FrameOverlay = (props: IFrameOverlayProps) => {
    const divStyle = {
        height: '100%',
        width: '100%',
        top: '0',
        left: '0',
        display: 'none',
        position: 'fixed',
        background: 'rgba(34, 34, 34, 0.0)',
        zIndex: -1
    } as React.CSSProperties;

    const divStyleEnable = {
        height: '100%',
        width: '100%',
        top: '0',
        left: '0',
        display: 'block',
        position: 'fixed',
        background: 'rgba(34, 34, 34, 0.0)',
        zIndex: 150
    } as React.CSSProperties;

    return <div style={props.visibility ? divStyleEnable : divStyle} className="frameOverlay"></div>;
};

export default FrameOverlay;
